<template>
    <div id="weather-container">
      <v-carousel 
          :height=120 :show-arrows=false
      >
        <v-carousel-item
          v-for="(item, idx) in cities"
          :key="idx"
        >
          <div class="weather-location" v-if="item && item.weather && item.main">
            <div class="weather-icon">
              <a :href="getWeatherUrl(item.id)" target="_blank" rel="noopener noreferrer">
                <v-icon :class="'owf owf-' + item.weather[0].id + ''"></v-icon>
              </a>
            </div>
            <div class="weather-detail">
              <div class="city">{{ item.name }}</div>
              <div class="description">{{ item.weather[0].description }}</div>
              <div class="temperature-detail">
                <div class="low">
                  <span>Low:</span>
                  {{ item.main.temp_min.toFixed(0) }}
                  </div>
                <div class="high">
                  <span>High:</span>
                  {{ item.main.temp_max.toFixed(0) }}
                </div>
              </div>
            </div>
            <div class="weather-temp">
              <div class="temp">{{ Math.round(item.main.temp) }}&#176;</div>
            </div>
          </div>

        </v-carousel-item>
      </v-carousel>
    </div>
</template>

<script>
import weatherApi from '../../services/ApiService'

export default {
  name: 'Weather',
  data: () => ({
    cities: [],
    loading: true,
    noData: false
  }),
  methods: {
    fetchWeatherData () {
      this.loading = true
      this.noData = false

      weatherApi.fetchWeather()
        .then(response => {
          // support both: array of city objects (from individual calls) or group response { list: [...] }
          let cities = []
          if (Array.isArray(response)) {
            cities = response
          } else if (response && response.list) {
            cities = response.list
          } else if (response && response.length) {
            cities = Array.from(response)
          }

          // ensure we always have an array
          this.cities = cities || []
          this.loading = false
          this.noData = this.cities.length === 0

          // eslint-disable-next-line no-console
          console.log('weather response', response)
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
          this.loading = false
          this.noData = true
        })
    },
    getWeatherUrl (id) {
      var weatherUrl = "https://openweathermap.org/city/" + id
      return weatherUrl
    }
  },
  mounted () {
    this.fetchWeatherData()
  }
}
</script>

<style lang="scss" scoped>
  #weather-container {
    width: 300px;

    .weather-location {
      color: #fff;
      background-color: rgba(59,59,59,.3);
      text-shadow: 1px 1px 2px rgba(0,0,0,.1), -1px -1px 2px rgba(0,0,0,.1), -1px 1px 2px rgba(0,0,0,.1), 1px -1px 2px rgba(0,0,0,.1);
      padding: 8px 0 5px 0;

      display: flex;

      .weather-icon {
        flex: 1 0 20%;

        display: flex;
        justify-content: center;

        .owf {
          font-size: 40px;
        }
      }
      .weather-detail {
        flex: 1 0 auto;

        .city {
          font-weight: 700;
          line-height: 1.25;
        }
          
        .description:first-letter {
          text-transform: capitalize;
          line-height: 1;
        }

        .temperature-detail {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          font-size: .875rem;
          padding-top: 2px;

          .low, .high {
            flex: 1 0 50%;
          }
          .feels-like {
            flex: 1 0 100%;
          }
        }

      }
      .weather-temp {
        flex: 1 0 20%;

        display: flex;
        justify-content: center;
        
        .temp {
          font-size: 28px;
          align-self: center;
        }
      }
    }
  }
</style>

<style lang="scss">
  .v-carousel__controls {
    height: 40px;

    .v-carousel__controls__item {
      .v-btn__content > i {
        font-size: 12px !important;
      }
    }
  }
</style>